module.exports = __webpack_public_path__ + "img/full2-min.6e72909b.png";